import React from 'react'
import './Breadcrumb.css'

function Breadcrumb({data}) {
  return (
    <div className='breadcrumb-section'>
        <h1 className='bread-crumb-heading'>{data}</h1>
      {/* <ul>
        <li className='isActive'>Dashboard</li>
        /
        <li>Event Knowledge</li>
      </ul> */}
    </div>
  )
}

export default Breadcrumb
